/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const DEFAULT_LANGUAGE = 'en-US'

export const DEBUG_LANGUAGE = 'DEBUG'
